/**
 * Newer calculators card each column - an outlined form beside a filled result panel - rather than
 * wrapping the whole widget in one card the way `LegacyCalculatorShell` does. The two gaps differ
 * because result panels stack larger blocks than form fields.
 */

export const CALCULATOR_FORM_CARD = 'flex flex-col gap-6 rounded-xl border border-border-primary bg-bg-primary p-6';

export const CALCULATOR_RESULT_CARD = 'flex flex-col gap-8 rounded-xl bg-bg-raised-secondary p-6';
